export enum ReportStep {
	/**
	 * Location
	 */
	// Splitting point where we either start into the premise flow or go to the non-premise flow

	// Starting point for non-premise reports
	NonPremise = 'questions/nonPremiseLocation',

	/**
	 * Reporter (Also the starting point for premise reports)
	 */
	Reporter = 'questions/reporter',
	Notifications = 'questions/reporter/notifications',

	// Generic problem type
	ProblemType = 'questions/problemType',
	GLNProblemType = 'questions/problemType/gln',

	/**
	 * Safety
	 */
	TrappedContact = 'questions/trappedContact',
	PowerLine = 'questions/powerLine',
	Power = 'questions/power',
	Hazard = 'questions/hazard',
	EmergencyResponse = 'questions/safety/emergencyResponse',
	PoliceFireEmergencyResponse = 'questions/safety/emergencyResponse/policeFire',

	/**
	 * Equipment damage
	 */
	EquipmentProblem = 'questions/equipment',
	Tree = 'questions/tree',
	OverheadWire = 'questions/equipment/overhead',
	Pole = 'questions/equipment/overhead/pole',
	UndergroundWire = 'questions/equipment/underground',
	OverheadTransformer = 'questions/equipment/overhead/transformer',
	UndergroundTransformer = 'questions/equipment/underground/transformer',
	Manhole = 'questions/equipment/manhole',
	Debris = 'questions/debris',
	PoleDebris = 'questions/poleDebris',

	/**
	 * Review and submit
	 */
	Review = 'questions/review',
	Confirmation = 'confirmation',
}
